<template>
  <div class="addStaff">
    <OACard header="基本信息" required="true">
      <form-component :form-data="formOne" ref="formOne" label-width="150px"></form-component>
    </OACard>
    <OACard header="入职信息" required="true">
      <form-component :form-data="formTwo" ref="formTwo" label-width="150px"></form-component>
    </OACard>
    <OACard class="text-center">
      <el-button @click="editStaff" type="primary" v-if="userId&&editDisabled">修改资料</el-button>
      <el-button @click="formSubmit" type="primary" :loading="loading" v-if="!userId||!editDisabled">保存</el-button>
      <el-button @click="resetForm" type="warning" v-if="!userId">重置</el-button>
    </OACard>
    <otherTable :evaluate="false" v-if="userId||talentsId" :userId="userId||talentsId"></otherTable>
  </div>
</template>
<script>
  import otherTable from "@/components/otherTable/otherTable";
  import OACard from "@/components/OACard/OACard";
  import formComponent from "@/components/formComponents/form-component";
  import {
    sex,
    recommend,
    countryPhoneCodeData
  } from "@/common/dictionary.js";
  import {
    getUrlQuery,
    getValue,
    resFilter,
    setValue,
    clearValue
  } from "@/common/util.js";
  import commonApi from "@/services/common.js";
  import staffApi from "@/services/staff.js";
  import {
    validMobile,
    validIdCard,
    validateNozho
  } from "@/common/valid.js";

  export default {
    name: "staffDetail",
    components: {
      OACard,
      formComponent,
      otherTable
    },
    data() {
      let that = this,
        isEdit = false;
      return {
        query: {},
        formOne: {
          name: {
            formType: "a-input",
            value: undefined,
            col: 8,
            placeholder: "请输入真实姓名",
            label: "真实姓名：",
            disabled: isEdit,
            rules: [{
              required: true,
              message: "请输入真实姓名",
              trigger: "change"
            }]
          },
          uniqueCode: {
            formType: "a-input",
            value: undefined,
            col: 8,
            placeholder: "请输入身份证号/证件号",
            label: "身份证号/证件号：",
            disabled: isEdit,
            rules: [{
                required: true,
                message: "请输入身份证号/证件号",
                trigger: "change"
              }
            ]
          },
          sex: {
            formType: "a-radio",
            value: undefined,
            options: sex,
            // disabled: true,
            col: 8,
            label: "性别：",
            rules: [{
                required: true,
                message: "请选择性别",
                trigger: "change"
              }
            ]
            // displayWith: (from, item) => {
            //   if (that.query.userId || that.query.talentsId) {
            //     return true;
            //   }
            // }
          },
          nation: {
            formType: "a-select",
            value: undefined,
            col: 8,
            code: 103,
            placeholder: "请选择民族",
            disabled: isEdit,
            label: "民族：",
            options: []
          },
          place: {
            formType: "a-input",
            value: undefined,
            col: 8,
            placeholder: "请输入籍贯",
            disabled: isEdit,
            label: "籍贯："
          },
          political: {
            formType: "a-select",
            value: undefined,
            col: 8,
            code: 105,
            placeholder: "请选择政治面貌",
            disabled: isEdit,
            label: "政治面貌：",
            options: []
          },
          marital: {
            formType: "a-select",
            value: undefined,
            col: 8,
            code: 104,
            placeholder: "请选择婚姻状况",
            disabled: isEdit,
            label: "婚姻状况：",
            options: []
          },
          areaIDCardAddr: {
            formType: "a-province",
            value: undefined,
            col: 8,
            placeholder: "请选择省市区",
            label: "身份证省市区：",
            disabled: isEdit,
            options: []
          },
          idCardAddr: {
            formType: "a-input",
            value: undefined,
            col: 8,
            placeholder: "请输入身份证地址",
            disabled: isEdit,
            label: "身份证地址："
          },
          areaNowAddr: {
            formType: "a-province",
            value: undefined,
            col: 8,
            placeholder: "请选择省市区",
            label: "居住地省市区：",
            disabled: isEdit,
            options: []
          },
          nowAddr: {
            formType: "a-input",
            value: undefined,
            col: 8,
            placeholder: "请输入居住地地址",
            disabled: isEdit,
            label: "居住地地址："
          },
          idCardFrontFileName: {
            formType: "sky-upload-img",
            value: [],
            col: 8,
            disabled: isEdit,
            limit: 3,
            label: "身份证正面：",
            platform: 'oa-pri-oss',
          },
          idCardContraryFileName: {
            formType: "sky-upload-img",
            value: [],
            col: 8,
            limit: 3,
            disabled: isEdit,
            label: "身份证反面：",
            platform: 'oa-pri-oss',
          },
          studentIdCardFileName: {
            formType: "sky-upload-img",
            value: [],
            col: 8,
            disabled: isEdit,
            limit: 3,
            label: "学生证：",
            platform: 'oa-pri-oss',
          },
          academicFileName: {
            formType: "sky-upload-img",
            value: [],
            col: 8,
            disabled: isEdit,
            limit: 3,
            label: "学历证书：",
            platform: 'oa-pri-oss',
          },
          dimissionCertificateFileName: {
            formType: "sky-upload-img",
            value: [],
            limit: 3,
            disabled: isEdit,
            col: 8,
            label: "离职证明：",
            platform: 'oa-pri-oss',
          }
        },
        formTwo: {
          englishName: {
            formType: "a-input",
            value: undefined,
            col: 8,
            placeholder: "请输入英文名",
            disabled: isEdit,
            label: "英文名：",
            rules: [{
              required: true,
              message: "请输入英文名",
              trigger: "change"
            }]
          },
          areaCode: {
            formType: "a-select",
            value: '+86',
            options: countryPhoneCodeData,
            disabled: isEdit,
            col: 8,
            placeholder: "请选择国家/地区",
            label: "国家/地区：",
            rules: [{
              required: true,
              message: "请选择国家/地区",
              trigger: "change"
            }]
          },
          mobile: {
            formType: "a-input",
            value: undefined,
            col: 8,
            placeholder: "请输入联系电话",
            label: "联系电话：",
            disabled: isEdit,
            rules: [{
                required: true,
                message: "请输入联系电话"
              }
            ]
          },
          employeeType: {
            formType: "a-select",
            value: undefined,
            options: [],
            disabled: isEdit,
            col: 8,
            code: 108,
            placeholder: "请选择员工类型",
            label: "员工类型：",
            rules: [{
              required: true,
              message: "请选择员工类型",
              trigger: "change"
            }]
          },
          companyId: {
            formType: "a-select",
            value: undefined,
            options: [],
            disabled: isEdit,
            col: 8,
            api: "getCompany",
            props: {
              label: "companyName",
              value: "id"
            },
            placeholder: "请选择所在公司",
            label: "所在公司：",
            change: (from, item) => {
              that.formTwo.number.companyId = item.value;
            },
            rules: [{
              required: true,
              message: "请选择所在公司",
              trigger: "change"
            }]
          },
          departmentIds: {
            formType: "a-depart-cascader",
            value: undefined,
            col: 8,
            disabled: isEdit,
            placeholder: "请选择所在部门",
            label: "所在部门：",
            change: (formData, item) => {
              formData.positionId.departId = _.last(item.value);
            },
            rules: [{
              required: true,
              message: "请选择所在部门",
              trigger: "change"
            }]
          },
          positionId: {
            formType: "a-post-select",
            value: undefined,
            departId: "",
            col: 8,
            disabled: isEdit,
            placeholder: "请选择职位",
            label: "职位：",
            props: {
              label: "positionName",
              value: "id"
            },
            rules: [{
              required: true,
              message: "请选择职位",
              trigger: "change"
            }]
          },
          birthDate: {
            formType: "a-span",
            value: undefined,
            col: 8,
            disabled: isEdit,
            label: "员工生日：",
            displayWith: (from, item) => {
              if (that.query.userId || that.query.talentsId) {
                return true;
              }
            }
          },
          birthTye: {
            formType: "a-select",
            value: 159001,
            options: [],
            disabled: false,
            col: 8,
            code: '159',
            props: {
              label: "describe",
              value: "code"
            },
            rules: [{
              required: true,
              message: "请选择生日贺卡类型",
              trigger: "change"
            }],
            placeholder: "请选择生日贺卡类型",
            label: "生日贺卡类型：",
          },
          birthDateChinese: {
            formType: "a-date-picker",
            type: "date",
            value: undefined,
            placeholder: "请选择生日",
            label: "生日：",
            disabled: isEdit,
            col: 8,
            rules: [{
              required: true,
              message: "请选择生日",
              trigger: "change"
            }],
          },
          inductionTime: {
            formType: "a-date-picker",
            type: "date",
            value: undefined,
            placeholder: "请选择入职时间",
            label: "入职时间：",
            disabled: isEdit,
            col: 8,
            rules: [{
              required: true,
              message: "请选择入职时间",
              trigger: "change"
            }]
          },
          companyEmail: {
            formType: "a-input-select",
            value: undefined,
            disabled: isEdit,
            col: 8,
            placeholder: "英文名_姓",
            api: "getcompanydomains",
            label: "企业邮箱：",
            rules: [{
                required: true,
                message: "请输入邮箱",
                trigger: "change"
              },
              {
                trigger: "change",
                validator: validateNozho
              }
            ]
          },
          bankNumber: {
            formType: "a-input",
            value: undefined,
            col: 8,
            disabled: isEdit,
            placeholder: "请输入银行卡号",
            label: "银行卡号："
          },
          doorCardNumber: {
            formType: "a-input",
            value: undefined,
            col: 8,
            disabled: isEdit,
            placeholder: "请输入门禁卡号",
            label: "门禁卡编号："
          },
          number: {
            formType: "a-get-number",
            value: undefined,
            col: 8,
            disabled: isEdit,
            placeholder: "请获取工号",
            label: "工号：",
            companyId: undefined,
            rules: [{
              required: true,
              message: "请获取工号",
              trigger: "change"
            }]
          },
          emergencyContact: {
            formType: "a-input",
            value: undefined,
            col: 8,
            disabled: isEdit,
            placeholder: "请输入紧急联系人",
            label: "紧急联系人："
          },
          emergencyPhone: {
            formType: "a-input",
            value: undefined,
            col: 8,
            disabled: isEdit,
            placeholder: "请输入紧急联系电话",
            label: "紧急联系电话："
          },
          isHave: {
            formType: "a-radio",
            value: 1,
            col: 8,
            disabled: isEdit,
            options: recommend,
            label: "有无推荐人："
          },
          recommend: {
            formType: "a-input",
            value: undefined,
            col: 8,
            disabled: isEdit,
            placeholder: "请输入推荐人名称",
            label: "推荐人名称：",
            displayWith: (from, item) => {
              return from.isHave.value == 0;
            }
          },
          remark: {
            formType: "a-textarea",
            value: undefined,
            col: 8,
            disabled: isEdit,
            placeholder: "请输入备注",
            label: "备注：",
            rules: [{
              max: 500,
              message: "请输入500字符以内的内容"
            }]
          }
        },
        loading: false,
        userId: "",
        talentsId: "",
        detail: {},
        editDisabled: false
      };
    },
    methods: {
      async getDetail(id) {
        let res = await staffApi.getDetail({
          id: id
        });
        this.detail = res.data.data;
        setValue(res.data.data, {
          ...this.formOne,
          ...this.formTwo
        });
        this.formTwo.positionId.departId = _.last(this.detail.departmentIds);
        this.formTwo.number.companyId = this.detail.companyId;
        this.formTwo.companyEmail.value = [
          this.detail.companyEmail,
          this.detail.domainName
        ];
        if (res.data.data.recommend) {
          this.formTwo.isHave.value = 0;
        } else {
          this.formTwo.isHave.value = 1;
        }
        this.editStaff();
      },
      editStaff() {
        _.forEach(this.formOne, function (value, key) {
          if (key != "sex") {
            value.disabled = !value.disabled;
          }
        });
        _.forEach(this.formTwo, function (value, key) {
          if (key != "sex") {
            value.disabled = !value.disabled;
          }
        });
        this.editDisabled = !this.editDisabled;
      },
      formSubmit() {
        this.$refs.formOne.validate(valid => {
          if (valid) {
            this.$refs.formTwo.validate(async valid => {
              if (valid) {
                let param = {};
                _.mapKeys({
                  ...this.formOne,
                  ...this.formTwo
                }, (value, key) => {
                  if (value.formType == "sky-upload-img") {
                    param[key] = value.value.map(item => {
                      return {
                        fileName: item.fileName,
                        ossName: item.ossName,
                        url: item.url
                      }
                    });
                  } else {
                    param[key] = value.value;
                  }
                });
                if (param.companyEmail && param.companyEmail.length) {
                  param.domainName = param.companyEmail[1];
                  param.companyEmail = param.companyEmail[0];
                }
                delete param.isHave;
                param.inductionTime += " 00:00:00";
                let res;
                if (this.userId) {
                  param["id"] = this.userId;
                  res = await staffApi.editStaff(param);
                  resFilter(res, this.getDetail(this.userId));
                } else if (this.talentsId) {
                  param["id"] = this.talentsId;
                  res = await staffApi.addStaff(param);
                  if (res.status == 200) {
                    this.$message.success("入职成功");
                    this.userId = res.data.data;
                    this.getDetail(res.data.data);
                  }
                } else {
                  res = await staffApi.addStaff(param);
                  if (res.status == 200) {
                    this.$message.success("添加成功");
                    this.userId = res.data.data;
                    this.getDetail(res.data.data);
                  }
                }
              }
            });
          }
        });
      },
      resetForm() {
        clearValue(this.formOne);
        clearValue(this.formTwo);
        this.$refs.formOne.$children[0].resetFields();
        this.$refs.formTwo.$children[0].resetFields();
      },
      isDisabled(val) {
        _.forEach(this.formOne, function (value, key) {
          if (key != "sex") {
            value.disabled = val;
          }
        });
        _.forEach(this.formTwo, function (value, key) {
          if (key != "sex") {
            value.disabled = val;
          }
        });
      }
    },
    mounted() {
      this.query = getUrlQuery();
      this.talentsId = this.query && this.query.talentsId;
      this.talentsId && this.getDetail(this.talentsId);
      this.userId = this.query && this.query.userId;
      this.userId && this.getDetail(this.userId);
      if (this.talentsId) {
        this.isDisabled(true);
      }
    }
  };

</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/personnel/staffDetail.vue